export const DrillingIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M970 5020 c-19 -19 -20 -33 -20 -310 0 -313 2 -325 55 -388 51 -61
95 -76 233 -80 l122 -4 0 -224 c0 -166 4 -233 13 -257 20 -47 64 -95 111 -120
39 -21 56 -22 289 -25 l247 -3 0 -765 c0 -668 2 -769 15 -795 39 -74 419 -592
449 -610 41 -25 111 -25 152 0 30 18 410 536 449 610 13 26 15 127 15 795 l0
765 248 3 c233 3 249 4 289 25 51 27 96 82 112 132 7 24 11 121 11 254 l0 215
123 4 c137 4 181 19 232 80 53 63 55 75 55 388 0 277 -1 291 -20 310 -20 20
-33 20 -1590 20 -1557 0 -1570 0 -1590 -20z m3060 -351 l0 -231 -29 -29 -29
-29 -1412 0 -1412 0 -29 29 -29 29 0 231 0 231 1470 0 1470 0 0 -231z m-410
-643 c0 -213 0 -215 -24 -243 l-24 -28 -1012 0 -1012 0 -24 28 c-24 28 -24 30
-24 243 l0 214 1060 0 1060 0 0 -214z m-660 -468 l0 -53 -383 -174 c-210 -96
-390 -178 -399 -183 -17 -8 -18 6 -18 227 l0 235 400 0 400 0 0 -52z m0 -425
l-1 -218 -350 -160 c-193 -88 -373 -170 -400 -182 l-49 -22 0 218 0 217 78 34
c42 19 221 101 397 182 176 81 321 147 323 148 1 0 2 -98 2 -217z m0 -581 l0
-208 -347 -159 c-192 -87 -356 -162 -365 -167 -13 -6 -24 3 -52 41 l-36 49 0
144 0 144 398 182 c218 100 398 182 400 182 1 0 2 -94 2 -208z m-195 -717
c-109 -151 -201 -275 -205 -275 -8 0 -228 302 -236 325 -3 6 127 71 313 156
l318 146 3 -38 c3 -36 -11 -58 -193 -314z"
      />
      <path
        d="M1350 4762 c-93 -47 -106 -166 -24 -231 40 -32 85 -36 137 -13 54 24
77 62 77 124 0 54 -27 100 -73 121 -45 22 -73 21 -117 -1z"
      />
      <path
        d="M261 3095 c-24 -7 -59 -28 -78 -47 -66 -64 -63 8 -63 -1452 0 -727 4
-1338 9 -1359 14 -58 51 -105 105 -132 l50 -25 2276 0 2276 0 50 25 c54 27 91
74 105 132 13 58 12 2650 -2 2714 -8 35 -23 64 -46 90 -64 71 -53 70 -814 67
-726 -3 -692 -1 -752 -57 -66 -60 -62 -2 -65 -921 -2 -754 -4 -836 -19 -852
-15 -17 -56 -18 -733 -18 -677 0 -718 1 -733 18 -15 16 -17 98 -19 852 -3 901
0 852 -57 913 -60 65 -18 62 -766 64 -556 2 -688 -1 -724 -12z m1384 -150 l25
-24 0 -825 c0 -558 3 -834 11 -853 15 -40 57 -82 104 -104 38 -18 81 -19 775
-19 694 0 737 1 775 19 47 22 89 64 104 104 8 19 11 295 11 853 l0 825 25 24
24 25 654 0 c630 0 656 -1 678 -19 l24 -19 3 -1319 c1 -725 0 -1328 -3 -1340
-3 -12 -12 -29 -21 -37 -14 -14 -235 -16 -2273 -16 -1934 0 -2260 2 -2277 14
-19 14 -19 39 -19 1356 l0 1342 24 19 c22 18 48 19 678 19 l654 0 24 -25z"
      />
    </g>
  </svg>
);
